import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-rightArrow",
  "use": "icon-rightArrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-rightArrow\"><path d=\"M734.44318152 498.57670462l-345.17045462-266.54829538c-17.2585231-13.42329538-30.68181848-7.67045462-30.68181766 13.42329538v533.09659076c0 21.09375 13.42329538 26.84659075 30.68181766 13.42329537l345.17045462-266.54829537c9.58806848-7.67045462 9.58806848-19.17613613 0-26.84659076z\" p-id=\"7515\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol